<template>
  <div>
    <v-container v-if="!loading">
      <v-tabs grow v-model="currentTab" center-active>
        <v-tab v-for="items in CF4Compotents" :key="items.comp" class="font-weight-black">
          {{ items.name }}
        </v-tab>
        <v-tab-item v-for="items in CF4Compotents" :key="items.comp">
          <v-card flat tile>
            <patient-profile :currentTab="currentTab" :formData="formData" v-if="items.comp === 'PatientProfile'"/>
            <chief-complaint :currentTab="currentTab" :formData="formData" v-if="items.comp === 'ChiefComplaint'"/>
            <present-illness :currentTab="currentTab" :formData="formData"
                             v-if="items.comp === 'HistoryPresentIllness'"/>
            <past-med-history :currentTab="currentTab" :formData="formData"
                              v-if="items.comp === 'PertinentPastMedicalHistory'"/>
            <ob-gyne :currentTab="currentTab" :formData="formData" v-if="items.comp === 'OBGyneHistory'"/>
            <sign-symptoms :currentTab="currentTab" :formData="formData" v-if="items.comp === 'PertinentSignSymptoms'"/>
            <referred-hci :currentTab="currentTab" :formData="formData" v-if="items.comp === 'ReferredHCI'"/>
            <physical-exam :currentTab="currentTab" :formData="formData" v-if="items.comp === 'PhysicalExamination'"/>
            <course-ward :currentTab="currentTab" :formData="formData" v-if="items.comp === 'CourseWard'"/>
            <outcome-treatment :currentTab="currentTab" :formData="formData" v-if="items.comp === 'OutcomeTreatment'"/>
            <professional-certification :currentTab="currentTab" :formData="formData" v-if="items.comp === 'ProfessionalCertification'"/>
            <medicine :currentTab="currentTab" :formData="formData" v-if="items.comp === 'Medicine'"/>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-container>
    <v-container v-else style="text-align: center;">
      <v-progress-circular
          :size="150"
          color="primary"
          indeterminate
          style="text-align: center"
      >Loading Data
      </v-progress-circular>
    </v-container>
  </div>
</template>

<script>
import {mapState} from "vuex";
import CF4Compotents from '@/components/core/components';
import ChiefComplaint from "../CF4Components/ChiefComplaint";
import PatientProfile from "../CF4Components/PatientProfile";
import HistoryPresentIllness from "../CF4Components/HistoryPresentIllness";
import PertinentPastMedicalHistory from "../CF4Components/PertinentPastMedicalHistory";
import OBGyneHistory from "../CF4Components/OBGyneHistory";
import PertinentSignSymptoms from "../CF4Components/PertinentSignSymptoms";
import ReferredHCI from "../CF4Components/Referred";
import PhysicalExamination from "../CF4Components/PhysicalExamination";
import CourseWard from "../CF4Components/CourseWard";
import Medicine from "../CF4Components/Medicine";
import OutcomeTreatment from "../CF4Components/OutcomeTreatment";
import ProfessionalCertification from "../CF4Components/ProfessionalCertification";

export default {
  components: {
    'patient-profile': PatientProfile,
    'chief-complaint': ChiefComplaint,
    'present-illness': HistoryPresentIllness,
    'sign-symptoms': PertinentSignSymptoms,
    'referred-hci': ReferredHCI,
    'ob-gyne': OBGyneHistory,
    'past-med-history': PertinentPastMedicalHistory,
    'physical-exam': PhysicalExamination,
    'course-ward': CourseWard,
    'medicine': Medicine,
    'outcome-treatment': OutcomeTreatment,
    'professional-certification': ProfessionalCertification,
  },

  data() {
    return {
      CF4Compotents: CF4Compotents,
      loading: true,
      formData: {
        patient: {
          claim_id: '',
          transmittal_id: '',
          patient_pin: '',
          patient_type: '',
          last_name: '',
          first_name: '',
          middle_name: '',
          suffix: '',
          gender: '',
          dob: '',
          admission_date: '',
          discharge_date: '',
          admission_time: '',
          discharge_time: '',
          admitting_diagnosis: '',
          discharge_diagnosis: '',
          first_case_rate_code: '',
          second_case_rate_code: '',
        },
        chief_complaint: {
          chief_complaint: '',
        },
        present_illness: {
          present_illness: '',
        },
        past_medical: {
          past_medical: '',
        },
        sign_symptoms: [],
        referred_hci: {
          is_referred: 'N',
          reason: '',
          originating_hci: ''
        },
        ob_gyne: {
          is_applicable: 'N',
          lmp: '',
          gravidity: '',
          parity: '',
          full_term: '',
          premature: '',
          abortion: '',
          living_children: '',
        },
        physical_examination: {
          vital_sign: {
            systolic: '',
            diastolic: '',
            hr: '',
            rr: '',
            temp: '',
          },
          general_survey: {
            gen_survey_id: '',
            gen_survey_remark: '',
          },
          heent: [],
          chest: [],
          heart: [],
          abdomen: [],
          guie: [],
          skin: [],
          neuro: [],
        },
        course_ward: [],
        medicine: [],
        outcome_treatment: {
          outcome: '',
          reason: ''
        },
        professional_certification: {
          attending_physician: '',
        }
      },
      currentTab: 0,
      submitForm: false,
      pid: this.$route.params.pid || null
    }
  },
  methods: {
    submitted() {
      this.submitForm = true;
    },
  },
  computed: {
    ...mapState({
      cf4: state => state.cf4
    })
  },
  mounted() {
    window.onbeforeunload = function () {
      this.$router.push({
        path: '/sureclaims/cf4/create/'
      })
    }
    if (this.$bus) {
      this.$bus.on('nextTab', (data) => {
        this.currentTab = data;
      });
    }
    this.loading = false
    this.formData.patient = this.$store.state.cf4.patient;
  },

}
</script>

<style scoped>

</style>
